
import { createStore, applyMiddleware } from 'redux'
import { persistStore, persistReducer, createMigrate } from 'redux-persist'
import createSagaMiddleware from 'redux-saga'
import storage from 'redux-persist/lib/storage'
import { composeWithDevTools } from 'redux-devtools-extension'
import 'regenerator-runtime/runtime'

import sagas from './sagas'
import { rootReducer, initialStates } from './reducers'
import textsEn from '../app/languages/en.json'

const migrations = {
  0: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  1: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  2: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  3: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  4: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  5: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  6: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  7: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  8: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  9: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  10: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  11: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  12: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  13: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  14: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  15: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  16: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  17: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  18: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  19: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  20: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  21: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  22: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  23: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  24: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  25: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  26: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  27: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  28: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  29: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  30: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  31: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  32: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  33: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  34: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  35: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  36: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  37: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  38: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  39: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  40: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  41: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  42: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  43: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  44: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  45: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  46: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  47: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  48: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  49: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  50: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  51: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  52: () => initialStates,
  53: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  54: () => initialStates, /* clear all storage */
  55: state => ({ ...state, app: { ...state.app, texts: textsEn } }), /* update app.texts */
  56: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
  57: state => ({ ...state, app: { ...state.app, texts: textsEn } }),
}

const persistConfig = {
  key: 'root',
  version: Object.keys(migrations).length - 1,
  storage,
  migrate: createMigrate(migrations, { debug: false }),
}

const persistedReducer = persistReducer(persistConfig, rootReducer);
const sagaMiddleware = createSagaMiddleware();
const store = createStore(
  persistedReducer,
  {},
  composeWithDevTools(applyMiddleware(sagaMiddleware)),
);

const persistor = persistStore(store);
sagaMiddleware.run(sagas);

window.store = store;

export {
  store,
  persistor,
};
